import React, {Component} from 'react';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';

import CriticalCareSwitcher from './../../components/CriticalCareSwitcher/CriticalCareSwitcher';
import { findAnorexiaDiagnosis } from './../../helpers/DiagnosesHelper';
import * as actionTypes from './../../store/actions/criticalCareAction';
import fetchCriticalCareAction from './../../store/actions/fetch/fetchCriticalCareAction';
import Loader from './../../components/Loader/Loader';
import * as helpActionTypes from './../../store/actions/helpAction';
import * as productsActionTypes from './../../store/actions/productsAction';
import * as diagnosesActionTypes from './../../store/actions/diagnosesAction';

/**
 * Critical Care container
 */
class CriticalCare extends Component {
  componentDidMount() {
    const {fetchData} = this.props;
    fetchData();
  }

  handleOnSelect = (i) => {
    const { diagnosesData, onSelect, resetSelectedProducts, selectedDiagnoses,
      onRemoveDiagnosis, selected } = this.props;

    const anorexiaDiagnose = findAnorexiaDiagnosis(diagnosesData);

    // Remove anorexia diagnosis if critical care is deselected and anorexia was selected
    if (selected && anorexiaDiagnose !== -1 && selectedDiagnoses.includes(anorexiaDiagnose)) {
      onRemoveDiagnosis(anorexiaDiagnose);
    }

    resetSelectedProducts();
    onSelect(i);
  }

  handleOnSelectAnorexia = (i) => {
    const { diagnosesData, onSelectAnorexia, onSelectDiagnosis, onRemoveDiagnosis,
      selectedDiagnoses } = this.props;

    const anorexiaDiagnose = findAnorexiaDiagnosis(diagnosesData);

    // Toggle anorexia diagnosis selection based on current state
    if (anorexiaDiagnose !== -1) {
      if (selectedDiagnoses.includes(anorexiaDiagnose)) {
        onRemoveDiagnosis(anorexiaDiagnose);
      } else {
        onSelectDiagnosis(anorexiaDiagnose);
      }
    }

    onSelectAnorexia(i);
  }

  render() {
    const {data, error, pending, selected, defaultValues, ready,
      selectedWeightAdjustment, diagnosesReady, selectedDiagnoses,
      openModalWithContent, selectedAnorexia} = this.props;
    // If there is a need for default data
    if(!ready && !error && !pending && diagnosesReady) {
      defaultValues();
    }
    // If Animal type data is pending
    if(pending || !ready) return (
      <Loader/>
    );

    // Return switcher
    return (
      <div className='nppe2-fc-critical-care-switcher__wrapper'>
        {error && <span className='nppe2-fc-critical-care-switcher__error'>{error}</span>}
        {!error &&
        <CriticalCareSwitcher
          data={data}
          selected={selected}
          onSelect={this.handleOnSelect}
          onSelectAnorexia= {this.handleOnSelectAnorexia}
          selectedAnorexia={selectedAnorexia}
          selectedDiagnoses={selectedDiagnoses}
          selectedWeightAdjustment={selectedWeightAdjustment}
          openModalWithContent={openModalWithContent}
        />
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    selected: state.criticalCareReducer.selected,
    selectedAnorexia: state.criticalCareReducer.selectedAnorexia,
    error: state.criticalCareReducer.error,
    data: state.criticalCareReducer.data,
    pending: state.criticalCareReducer.pending,
    ready: state.criticalCareReducer.ready,
    selectedWeightAdjustment: state.weightAdjustmentReducer.selected,
    // Diagnosis text if none selected
    selectedDiagnoses: state.diagnosesReducer.selected,
    diagnosesReady: state.diagnosesReducer.ready,
    diagnosesData: state.diagnosesReducer.data,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators(
      {
        fetchData: fetchCriticalCareAction
      },
      dispatch,
    ),
    onSelect: (id) => dispatch({
      type: actionTypes.SELECT,
      selected: id,
    }),
    onSelectAnorexia: (id) => dispatch({
      type: actionTypes.SELECT_ANOREXIA,
      selected: id,
    }),
    defaultValues: () => dispatch({
      type: actionTypes.DEFAULT,
    }),
    resetSelectedProducts: () => dispatch({
      type: productsActionTypes.RESET_PRODUCTS,
    }),
    onSelectDiagnosis: (id) => dispatch({
      type: diagnosesActionTypes.SELECT,
      selected: id,
    }),
    onRemoveDiagnosis: (id) => dispatch({
      type: diagnosesActionTypes.REMOVE,
      removed: id,
    }),
    openModalWithContent: (key) => dispatch({
      type: helpActionTypes.OPEN_MODAL_WITH_CONTENT,
      key: key,
      open: true,
    }),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(CriticalCare);

